import type {
  BenefitSummary,
  MarginInventoryLatestEntry,
  MarginInventoryLatestResponse,
  MarginTerm,
} from "@yutai/shared"

// 一般信用在庫ページの「今月優待 × 直近在庫」一覧。
// 無期限のCSVは今月の優待と無関係な銘柄も全部含むので、今月が権利確定月の優待銘柄だけに絞る。

export interface ThisMonthInventoryRow {
  code: string
  name: string
  benefit: BenefitSummary
  inventory: Partial<Record<MarginTerm, MarginInventoryLatestEntry>>
  /** 14日・無期限のどちらかで在庫が1株以上ある */
  inStock: boolean
}

export function thisMonthBenefits(benefits: BenefitSummary[], month: number): BenefitSummary[] {
  return benefits.filter((b) => b.recordMonths.includes(month))
}

function quantityOf(row: ThisMonthInventoryRow, term: MarginTerm): number {
  return row.inventory[term]?.quantity ?? -1
}

/**
 * 直近のアップロードに載っている銘柄（どちらかの期限で quantity が null でない）だけを残す。
 * 並びは 14日在庫の多い順 → 無期限在庫の多い順 → 証券コード順。
 */
export function buildThisMonthInventoryRows(
  benefits: BenefitSummary[],
  latest: MarginInventoryLatestResponse
): ThisMonthInventoryRow[] {
  const rows: ThisMonthInventoryRow[] = []
  for (const b of benefits) {
    const inventory = latest[b.id] ?? {}
    const listed = Object.values(inventory).some((e) => e && e.quantity !== null)
    if (!listed) continue
    const inStock = Object.values(inventory).some((e) => (e?.quantity ?? 0) > 0)
    rows.push({ code: b.id, name: b.name, benefit: b, inventory, inStock })
  }
  return rows.sort(
    (a, b) =>
      quantityOf(b, "14d") - quantityOf(a, "14d") ||
      quantityOf(b, "unlimited") - quantityOf(a, "unlimited") ||
      a.code.localeCompare(b.code)
  )
}
